import Observable from "../observable";

/** 处理部分浏览器不支持webp */
export const imageSrcHandle = (src) => {
    const ifSupportWebp = Observable.state.ifSupportWebp
    return `${src}${ifSupportWebp ? '?x-oss-process=image/format,webp' : ''}`
}
